import * as DLPluckingRooster from './../../../DL/Admin/Games/PluckingRooster';

const SubmitGame = async (userData, score, acceptedTerms = true) => {
    try {
        const payload = {
            fullName: userData.fullName,
            phoneNumber: userData.phoneNumber,
            email: userData.email,
            companionType: userData.companionType || 'azul',
            score: score,
            acceptedTerms: acceptedTerms
        };

        const response = await DLPluckingRooster.SubmitGame(payload);

        if (response.success) {
            return { success: true, data: response.data };
        } else {
            let userMessage = '¡Ups! Ha habido un error con tu conexión de internet o datos móviles';
            
            if (response.status === 409) {
                userMessage = '¡Gracias por tu participación! Ya has jugado anteriormente';
            } else if (response.message) {
                userMessage = response.message;
            }

            return { success: false, message: userMessage };
        }
    }
    catch (e) {
        return { success: false, message: 'No ha sido posible enviar tu puntuación. Inténtalo de nuevo.' };
    }
};

const ValidatePlayer = async (email, phone) => {
    try {
        const response = await DLPluckingRooster.ValidatePlayer(email, phone);
        
        if (response.success) {
            return { success: true };
        } else {
            let msg = 'Error al validar tus datos.';

            if (response.status === 409) msg = '¡Gracias por tu participación! Ya has jugado anteriormente';
            
            return { success: false, message: msg };
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible validar tus datos. Inténtalo nuevamente o inténtalo más tarde' }
    }
};

const ShowOverlay = async () => {
    return await DLPluckingRooster.ShowOverlay();
};

const HideOverlay = async () => {
    return await DLPluckingRooster.HideOverlay();
};

const RefreshOverlay = async () => {
    return await DLPluckingRooster.RefreshOverlay();
};

const ConfigOverlay = async (layoutMode, offset) => {
    return await DLPluckingRooster.ConfigOverlay({ layoutMode: layoutMode, positionOffset: offset });
};

const ConfigGame = async (duration) => {
    if(duration < 5) return { success: false, message: 'La duración mínima es 5 segundos' };
    return await DLPluckingRooster.ConfigGame({ durationSeconds: duration });
};

const ResetGame = async () => {
    return await DLPluckingRooster.ResetGame();
};

// =================================================================================================
// NUEVAS FUNCIONES ESTILO BARRIO 9 (QUIZZ)
// =================================================================================================

const GetSettings = async () => {
    try {
        return await DLPluckingRooster.GetSettings();
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar la configuración del overlay.' };
    }
};

const GetAdminParticipants = async () => {
    try {
        return await DLPluckingRooster.GetAdminParticipants();
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar el listado de participantes.' };
    }
};

const SelectWinner = async (id) => {
    try {
        return await DLPluckingRooster.SelectWinner(id);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al establecer el ganador.' };
    }
};

const UpdatePosition = async (offset) => {
    try {
        return await DLPluckingRooster.UpdatePosition(offset);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar desplazar la pantalla.' };
    }
};

const UpdateBannerMode = async (mode) => {
    try {
        return await DLPluckingRooster.UpdateBannerMode(mode);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la configuración del banner.' };
    }
};

const UpdateOverlayVisibility = async (visible) => {
    try {
        return await DLPluckingRooster.UpdateOverlayVisibility(visible);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la visibilidad del overlay.' };
    }
};

const TrackMetric = async (eventName, sessionId, source) => {
    try {
        return await DLPluckingRooster.TrackMetric(eventName, sessionId, source);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar guardar la métrica.' };
    }
};

const GetAdminStats = async () => {
    try {
        return await DLPluckingRooster.GetAdminStats();
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar obtener las estadísticas.' };
    }
};

const ToggleActiveGame = async (active) => {
    try {
        return await DLPluckingRooster.ToggleActiveGame(active);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar el estado del juego.' };
    }
};

export {
    SubmitGame,
    ValidatePlayer,
    ShowOverlay,
    HideOverlay,
    RefreshOverlay,
    ConfigOverlay,
    ConfigGame,
    ResetGame,
    GetSettings,
    GetAdminParticipants,
    SelectWinner,
    UpdatePosition,
    UpdateBannerMode,
    UpdateOverlayVisibility,
    TrackMetric,
    GetAdminStats,
    ToggleActiveGame
};